/**
 * <strong>Purpose:</strong> <br>
 * This mixin ensures focus is applied to the focusNode of a widget when any portion of the widget is selected, and
 * manages the classes on the buttonNode and focusNode based on their focus state. It also manages the focus change
 * between buttonNode and focusNode based on the arrow keys.
 *
 * @module mw-form/mixins/property/SplitButtonToggleSplitButtonFocusMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "dojo/_base/lang",
        "dojo/keys",
        "dojo/on",

        "mw-dom-utils/domUtils"
    ],
    function (declare, lang, keys, on, domUtils) {
        return declare(null, {

            postCreate: function () {
                this.inherited(arguments);

                this.own(
                    on(this.buttonNode, "focus", lang.hitch(this, "_handleFocus")),
                    on(this.buttonNode, "blur", lang.hitch(this, "_handleBlur")),
                    on(this.focusNode, "focus", lang.hitch(this, "_handleFocus")),
                    on(this.focusNode, "blur", lang.hitch(this, "_handleBlur")),
                    on(this.buttonNode, "keydown", lang.hitch(this, "_handleKeyDown")),
                    on(this.focusNode, "keydown", lang.hitch(this, "_handleKeyDown"))
                );
            },

            _handleKeyDown: function (e) {
                var keyCode = e.keyCode;
                switch (keyCode) {
                case keys.DOWN_ARROW:
                    if (this.get("orientation") === "Vertical" && e.target.classList.contains("mwButtonNode")) {
                        this.focusNode.focus();
                    }
                    break;
                case keys.UP_ARROW:
                    if (this.get("orientation") === "Vertical" && e.target.classList.contains("mwFocusNode")) {
                        this.buttonNode.focus();
                    }
                    break;
                case keys.RIGHT_ARROW:
                    if (this.get("orientation") === "Horizontal" && e.target.classList.contains("mwButtonNode")) {
                        this.focusNode.focus();
                    }
                    break;
                case keys.LEFT_ARROW:
                    if (this.get("orientation") === "Horizontal" && e.target.classList.contains("mwFocusNode")) {
                        this.buttonNode.focus();
                    }
                    break;
                }
            },

            _handleFocus: function (e) {
                this.baseClass.split(" ").forEach(lang.hitch(this, function (className) {
                    domUtils.toggleClass(this.domNode, className + "Focused", true);
                }));
                domUtils.toggleClass(e.target, "mwNodeFocused", true);
            },

            _handleBlur: function (e) {
                this.baseClass.split(" ").forEach(lang.hitch(this, function (className) {
                    domUtils.toggleClass(this.domNode, className + "Focused", false);
                }));
                domUtils.toggleClass(e.target, "mwNodeFocused", false);
            }
        });
    });